export const updateNewTime = "updateNewTime";
export const updateIsAddTimeClicked = "updateIsAddTimeClicked";
export const updateTime = "updateTime";
export const updateIsEditTimeClicked = "updateIsEditTimeClicked";
export const updateTimeDataTable = "updateTimeDataTable";
export const updateIsViewTimeClicked = "updateIsViewTimeClicked";
